import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import BreadcrumbsDropdownContentQuery, {
	type BreadcrumbsDropdownContentQuery$data,
	type BreadcrumbsDropdownContentQuery$variables,
} from './__generated__/BreadcrumbsDropdownContentQuery.graphql.ts';

export function preloadBreadcrumbsDropdown({
	spaceKey,
	contentId,
}: {
	spaceKey: string;
	contentId?: string;
}): Promise<{
	data: BreadcrumbsDropdownContentQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<BreadcrumbsDropdownContentQuery$data, BreadcrumbsDropdownContentQuery$variables>({
		query: BreadcrumbsDropdownContentQuery,
		variables: {
			spaceKey,
			contentId,
			skipContent: !contentId,
		},
	});
}
